/* eslint-disable import/prefer-default-export */
import VueProgressBar from 'vue-progressbar';
import Vue from 'vue';
import HTTP from '../config/axios';
import ErrorHandler from '../config/ErrorHandler';

Vue.use(VueProgressBar, {
  color: 'rgb(67, 66, 93)',
  failedColor: 'red',
  thickness: '3px',
});

export const post = (url, data) => {
  Vue.prototype.$Progress.start();
  return new Promise((resolve, reject) => {
    HTTP.post(url, data)
      .then((response) => {
        Vue.prototype.$Progress.finish();
        if (url !== '/login') {
          ErrorHandler.success('Akcja zakończona powodzeniem');
        }
        resolve(response.data);
      }, (error) => {
        reject();
        Vue.prototype.$Progress.fail();
        ErrorHandler.popup(error);
      });
  });
};

export const put = (url, data) => {
  Vue.prototype.$Progress.start();
  return new Promise((resolve, reject) => {
    HTTP.put(url, data)
      .then((response) => {
        Vue.prototype.$Progress.finish();
        resolve(response.data);
      }, (error) => {
        reject();
        Vue.prototype.$Progress.fail();
        ErrorHandler.popup(error);
      });
  });
};

export const remove = (url) => {
  Vue.prototype.$Progress.start();
  return new Promise((resolve, reject) => {
    HTTP.delete(url)
      .then((response) => {
        Vue.prototype.$Progress.finish();
        resolve(response.data);
      }, (error) => {
        reject();
        Vue.prototype.$Progress.fail();
        ErrorHandler.popup(error);
      });
  });
};

export const getWithParams = (url, params = {}) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$Progress.start();
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== null && v !== undefined && v !== ''),
    );
    HTTP.get(url, { params: cleanParams })
      .then((response) => {
        Vue.prototype.$Progress.finish();
        resolve(response.data);
      }, (error) => {
        reject(error);
        Vue.prototype.$Progress.fail();
        ErrorHandler.popup(error);
      });
  });
};

export const get = (url) => {
  return new Promise((resolve, reject) => {
    Vue.prototype.$Progress.start();
    HTTP.get(url)
      .then((response) => {
        Vue.prototype.$Progress.finish();
        resolve(response.data);
      }, (error) => {
        reject();
        Vue.prototype.$Progress.fail();
        ErrorHandler.popup(error);
      });
  });
};
export const getPDF = async (url) => {
  try {
    return await HTTP.get(url, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/pdf',
        Accept: 'application/pdf',
      },
    });
  } catch (e) {
    console.log(e.response);
    ErrorHandler.popup(e);
    throw e;
  }
};

export const getExcel = async (url) => {
  try {
    return await HTTP.get(url, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/vnd.oasis.opendocument.spreadsheet',
        Accept: 'application/*',
      },
    });
  } catch (e) {
    console.log(e.response);
    ErrorHandler.popup(e);
    throw e;
  }
};

export const postExcel = async (url, data) => {
  try {
    return await HTTP.post(url, data, {
      responseType: 'arraybuffer',
      // headers: {
      //   'Content-Type': 'application/vnd.oasis.opendocument.spreadsheet',
      //   Accept: 'application/*',
      // },
    });
  } catch (e) {
    console.log(e.response);
    ErrorHandler.popup(e);
    throw e;
  }
};

export const patch = (url, data) => {
  return new Promise((resolve, reject) => {
    HTTP.patch(url, data)
      .then((response) => {
        resolve(response.data);
      }, (error) => {
        reject();
        ErrorHandler.popup(error);
      });
  });
};
